// Centralized product data with slugs for URL routing
export const products = {
  tshirt: [
    {
      slug: 'eternal-evolution',
      title: 'Eternal Evolution',
      price: '40.00',
      description: 'A powerful design that represents the continuous journey of personal growth and transformation. This premium cotton t-shirt features our Eternal Evolution graphic that symbolizes the never-ending process of becoming your best self.',
      primaryImage: '/images/eternal_evolution_transparent_mockup.png',
      hoverImage: '/images/eternal_evolution_graphic.png',
      // Custom images for product detail page
      detailImages: [
        '/images/eternal_evolution_transparent_mockup.png',
        '/images/eternal_evolution_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      // Color-specific images
      colorImages: {
        'Black': [
          '/images/eternal_evolution_transparent_mockup.png',
          '/images/eternal_evolution_graphic.png',
          '/images/front_logo_transparent_mockup.png'
        ],
        'White': [
          '/images/eternal_evolution_inverted_transparent_mockup.png',
          '/images/eternal_evolution_graphic_inverted.png',
          '/images/front_logo_inverted_mockup.png'
        ]
      },
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      colors: ['Black', 'White'],
      inStock: true
    },
    {
      slug: 'eternal-awakening',
      title: 'Eternal Awakening',
      price: '40.00',
      description: 'Awaken to your higher self. A clean, powerful graphic that symbolizes new beginnings and inner light.',
      primaryImage: '/images/eternal_awakening_mockup_transparent.png',
      hoverImage: '/images/eternal_awakening_graphic.png',
      detailImages: [
        '/images/eternal_awakening_transparent_mockup.png',
        '/images/eternal_awakening_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'eternal-sun',
      title: 'Eternal Sun',
      price: '40.00',
      description: 'Premium cotton t-shirt featuring our elegant geisha design. Perfect for those who appreciate the beauty of traditional artistry and modern spiritual expression.',
      primaryImage: '/images/geisha_transparent_mockup.png',
      hoverImage: '/images/geisha_graphic.png',
      // Custom images for product detail page
      detailImages: [
        '/images/geisha_mockup.png',
        '/images/geisha_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'eternal-rose',
      title: 'Eternal Rose',
      price: '40.00',
      description: 'Elegant and timeless, this design embodies the beauty of eternal love and devotion. The intricate rose pattern symbolizes the delicate balance between strength and grace.',
      primaryImage: '/images/eternal_rose_transparent_mockup.png',
      hoverImage: '/images/eternal_rose_graphic.png',
      // Custom images for product detail page
      detailImages: [
        '/images/eternal_rose_transparent_mockup.png',
        '/images/eternal_rose_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      // Color-specific images
      colorImages: {
        'Black': [
          '/images/eternal_rose_transparent_mockup.png',
          '/images/eternal_rose_graphic.png',
          '/images/front_logo_transparent_mockup.png'
        ],
        'White': [
          '/images/eternal_rose_inverted_transparent_mockup.png',
          '/images/eternal_rose_graphic_inverted.png',
          '/images/front_logo_inverted_mockup.png'
        ]
      },
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL'],
      colors: ['Black', 'White'],
      inStock: true
    },
    {
      slug: 'woven-within',
      title: 'Woven From Within',
      price: '40.00',
      description: 'Embrace the dark elegance with our Goth Soul design. This piece captures the mysterious beauty of gothic aesthetics while maintaining a modern edge.',
      primaryImage: '/images/wfw_transparent_mockup.png',
      hoverImage: '/images/wfw_graphic.png',
      // Custom images for product detail page
      detailImages: [
        '/images/wfw_transparent_mockup.png',
        '/images/wfw_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      // Color-specific images
      colorImages: {
        'Black': [
          '/images/wfw_transparent_mockup.png',
          '/images/wfw_graphic.png',
          '/images/front_logo_transparent_mockup.png'
        ],
        'White': [
          '/images/wfw_inverted_transparent_mockup.png',
          '/images/wfw_graphic_inverted.png',
          '/images/front_logo_inverted_mockup.png'
        ]
      },
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      colors: ['Black', 'White'],
      inStock: true
    },
    {
      slug: 'classic-tee',
      title: 'Classic Tee',
      price: '40.00',
      description: 'The perfect blend of comfort and style. Our Classic Tee features a timeless design that never goes out of fashion. Made from premium cotton, this essential piece is a must-have for any wardrobe.',
      primaryImage: '/images/classic_tee_transparent_mockup.png',
      hoverImage: '/images/classic_tee_graphic.png',
      // Custom images for product detail page
      detailImages: [
        '/images/classic_tee_transparent_mockup.png',
        '/images/classic_tee_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      // Color-specific images
      colorImages: {
        'Black': [
          '/images/classic_tee_transparent_mockup.png',
          '/images/classic_tee_graphic.png',
          '/images/front_logo_transparent_mockup.png'
        ],
        'White': [
          '/images/classic_tee_inverted_mockup.png',
          '/images/classic_tee_graphic_inverted.png',
          '/images/front_logo_inverted_mockup.png'
        ]
      },
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      colors: ['Black', 'White'],
      inStock: true
    },
    {
      slug: 'eternal-battle',
      title: 'Eternal Battle',
      price: '40.00',
      description: 'Face your inner battles with strength and determination. This t-shirt features our Eternal Battle design, representing the ongoing struggle for personal growth and victory.',
      primaryImage: '/images/eternal_battle_transparent_mockup.png',
      hoverImage: '/images/eternal_battle_graphic.png',
      // Custom images for product detail page
      detailImages: [
        '/images/eternal_battle_transparent_mockup.png',
        '/images/eternal_battle_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'eternal-chaos',
      title: 'Eternal Chaos',
      price: '40.00',
      description: 'Embrace the beautiful chaos of life with this striking design. The Eternal Chaos t-shirt represents finding order within the storm and strength within the struggle.',
      primaryImage: '/images/eternal_chaos_transparent_mockup.png',
      hoverImage: '/images/eternal_chaos_graphic.png',
      // Custom images for product detail page
      detailImages: [
        '/images/eternal_chaos_transparent_mockup.png',
        '/images/eternal_chaos_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'boundless-soul',
      title: 'Boundless Soul',
      price: '40.00',
      description: 'A powerful design representing the infinite nature of the soul and its boundless potential.',
      primaryImage: '/images/boundless_soul_mockup_transparent.png',
      hoverImage: '/images/boundless_soul_graphic.png',
      detailImages: [
        '/images/boundless_soul_mockup_transparent.png',
        '/images/boundless_soul_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'embrace-your-soul',
      title: 'Embrace Your Soul',
      price: '40.00',
      description: 'Tap into your inner power with a bold design that celebrates the soul. Premium cotton tee with a clean front graphic and striking hover artwork.',
      primaryImage: '/images/embrace_your_soul.png',
      hoverImage: '/images/embrace_your_soul_graphic.png',
      detailImages: [
        '/images/embrace_your_soul.png',
        '/images/embrace_your_soul_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'eternal-love',
      title: 'Eternal Love',
      price: '40.00',
      description: 'Celebrate timeless connection with our Eternal Love design. Premium cotton tee with a bold heart-meets-infinity graphic.',
      primaryImage: '/images/eternal_love_mockup.png',
      hoverImage: '/images/eternal_love_graphic.png',
      detailImages: [
        '/images/eternal_love_mockup.png',
        '/images/eternal_love_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'unchained-soul',
      title: 'Unchained Soul',
      price: '40.00',
      description: 'Break free from limitations with a bold emblem of inner strength.',
      primaryImage: '/images/unchained_soul_mockup.png',
      hoverImage: '/images/unchained_soul_graphic.png',
      detailImages: [
        '/images/unchained_soul_mockup.png',
        '/images/unchained_soul_graphic.png',
        '/images/front_logo_transparent_mockup.png'
      ],
      category: 'tshirt',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    }
  ],
  hoodie: [
    {
      slug: 'eternal-awakening-hoodie',
      title: 'Eternal Awakening Hoodie',
      price: '60.00',
      description: 'A premium hoodie featuring the Eternal Awakening design with soft fleece lining.',
      primaryImage: '/images/eternal_awakening_hoodie.png',
      hoverImage: '/images/eternal_awakening_graphic.png',
      detailImages: [
        '/images/eternal_awakening_hoodie_transparent.png',
        '/images/eternal_awakening_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'embrace-your-soul-hoodie',
      title: 'Embrace Your Soul Hoodie',
      price: '60.00',
      description: 'Tap into your inner power with a bold design that celebrates the soul. Cozy fleece hoodie with a clean front graphic and striking artwork.',
      primaryImage: '/images/embrace_your_soul_hoodie.png',
      hoverImage: '/images/embrace_your_soul_graphic.png',
      detailImages: [
        '/images/embrace_your_soul_hoodie.png',
        '/images/embrace_your_soul_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'classic-hoodie',
      title: 'Classic Hoodie',
      price: '55.00',
      description: 'A classic hoodie with timeless design and comfortable fit.',
      primaryImage: '/images/classic_hoodie.png',
      hoverImage: '/images/classic_tee_graphic.png',
      detailImages: [
        '/images/classic_hoodie_transparent.png',
        '/images/classic_tee_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'eternal-chaos-hoodie',
      title: 'Eternal Chaos Hoodie',
      price: '60.00',
      description: 'A premium hoodie featuring the Eternal Chaos design with soft fleece lining.',
      primaryImage: '/images/eternal_chaos_hoodie_transparent.png',
      hoverImage: '/images/eternal_chaos_graphic.png',
      detailImages: [
        '/images/eternal_chaos_hoodie_transparent.png',
        '/images/eternal_chaos_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'eternal-sun-hoodie',
      title: 'Eternal Sun Hoodie',
      price: '60.00',
      description: 'A premium hoodie featuring the Eternal Sun design with soft fleece lining.',
      primaryImage: '/images/eternal_sun_hoodie_transparent.png',
      hoverImage: '/images/geisha_graphic.png',
      detailImages: [
        '/images/eternal_sun_hoodie_transparent.png',
        '/images/geisha_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'eternal-battle-hoodie',
      title: 'Eternal Battle Hoodie',
      price: '60.00',
      description: 'A premium hoodie featuring the Eternal Battle design with soft fleece lining.',
      primaryImage: '/images/eternal_battle_hoodie.png',
      hoverImage: '/images/eternal_battle_graphic.png',
      detailImages: [
        '/images/eternal_battle_hoodie_transparent.png',
        '/images/eternal_battle_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'boundless-soul-hoodie',
      title: 'Boundless Soul',
      price: '60.00',
      description: 'A premium hoodie featuring the Boundless Soul design with soft fleece lining.',
      primaryImage: '/images/boundless_soul_hoodie.png',
      hoverImage: '/images/boundless_soul_graphic.png',
      detailImages: [
        '/images/boundless_soul_hoodie_transparent.png',
        '/images/boundless_soul_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'eternal-love-hoodie',
      title: 'Eternal Love Hoodie',
      price: '60.00',
      description: 'A premium hoodie featuring the Eternal Love design with soft fleece lining.',
      primaryImage: '/images/eternal_love_hoodie.png',
      hoverImage: '/images/eternal_love_graphic.png',
      detailImages: [
        '/images/eternal_love_hoodie.png',
        '/images/eternal_love_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    },
    {
      slug: 'unchained-soul-hoodie',
      title: 'Unchained Soul Hoodie',
      price: '60.00',
      description: 'Break free from limitations with a bold emblem of inner strength.',
      primaryImage: '/images/unchained_soul_hoodie.png',
      hoverImage: '/images/unchained_soul_graphic.png',
      detailImages: [
        '/images/unchained_soul_hoodie.png',
        '/images/unchained_soul_graphic.png',
        '/images/front_logo_hoodie_mockup.png'
      ],
      category: 'hoodie',
      sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      inStock: true
    }
  ],
  collection: [
  ]
}

// Helper function to get all products across all categories
export const getAllProducts = () => {
  return Object.values(products).flat()
}

// Helper function to get products by category
export const getProductsByCategory = (category) => {
  return products[category] || []
}

// Helper function to get a specific product by category and slug
export const getProductBySlug = (category, slug) => {
  const categoryProducts = products[category] || []
  return categoryProducts.find(product => product.slug === slug)
}

// Helper function to get all available categories
export const getCategories = () => {
  return Object.keys(products)
}
